import { registerQuery } from '@adornis/baseql/metadata/register.js';
import type { BaseQLSelectionSet } from '@adornis/baseql/utils/queryGeneration.js';
import { getCurrentUserServerOrFail, loadRawEntityDataByQuery } from '@adornis/bh-util/util.js';
import { Permission } from '../enums/roles.js';
import { SuspensionLog } from '../logs/SuspensionLog.js';

export const getUserSuspensionHistory = registerQuery({
  operationName: 'getUserSuspensionHistory',
  type: () => [SuspensionLog],
  params: [{ name: 'userId', type: () => String }],
  resolve: (userId: string) => {
    return async (gqlFields: BaseQLSelectionSet<SuspensionLog>) => {
      const currentUser = await getCurrentUserServerOrFail();
      if (currentUser._id === userId) return loadRawEntityDataByQuery(SuspensionLog, { userID: userId }, gqlFields);

      const authorizationLogs = await loadRawEntityDataByQuery(
        SuspensionLog,
        { userID: userId },
        { _id: 1, suspension: { institutionID: 1 } },
      );
      const permittedLogIDs = authorizationLogs
        .filter(log => currentUser.hasPermission(Permission.VIEW_ADMIN_INSTITUTION_USERS, log.suspension.institutionID))
        .map(log => log._id);
      return loadRawEntityDataByQuery(SuspensionLog, { _id: { $in: permittedLogIDs } }, gqlFields);
    };
  },
});
